import { render, staticRenderFns } from "./FullSync.vue?vue&type=template&id=74487650&scoped=true&"
import script from "./FullSync.vue?vue&type=script&lang=js&"
export * from "./FullSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74487650",
  null
  
)

export default component.exports